import styled from "styled-components"

export const Entry = styled.div`
  margin-bottom: 1rem;
`

export const Label = styled.div`
  font-size: 1.2rem;
`

export const Value = styled.div`
  font-weight: 700;
  line-height: 1.4rem;
  display: flex;
  justify-content: flex-start;
`

export const LargeTotalEntry = styled.div`
  margin: 3rem 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  align-items: flex-end;
`

export const LargeValue = styled.div`
  margin-top: 1rem;
  font-size: 4rem;
  font-weight: 700;
`
